import * as React from 'react';

//import { CPlannerTask } from '../../Entity/PlannerTaskObj';

import { Callout } from 'office-ui-fabric-react/lib/Callout';
import './planner.scss';

import { DirectionalHint } from 'office-ui-fabric-react/lib/ContextualMenu';
//import { GraphRequest } from '../../Utils/GraphRequest';
import { Helper } from '../../Utils/Helper';
export interface IProps {
    categoryDescriptions,
    appliedCategories,
    AddCategoryMethod?;
    Phrases;
}
export interface IContextualMenuState {
    directionalHint?: DirectionalHint;
    directionalHintForRTL?: DirectionalHint;
    useDirectionalHintForRtl?: boolean;
    isBeakVisible?: boolean;
    gapSpace?: number;
    beakWidth?: number;
    edgeFixed?: boolean;
    isCalloutVisible?: boolean;
    Changed: Date;
}
/*const baseProductionCdnUrl = 'https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/';

const facepilePersonas: IFacepilePersona[] = [];*/

export default class TaskCategory extends React.Component<IProps, IContextualMenuState>{

    private _menuButtonElement: HTMLElement | null;
    private NewAppliedList = {};
    private originalAppCatList={};
    constructor(props: IProps) {
        super(props);
        if (this.props.appliedCategories) {
            this.NewAppliedList =JSON.parse(JSON.stringify(this.props.appliedCategories)) ;
            this.originalAppCatList = JSON.parse(JSON.stringify(this.props.appliedCategories)) ;
        }
        this.state = {
            isCalloutVisible: false,
            directionalHint: DirectionalHint.topCenter,
            beakWidth: 16,
            Changed: new Date()
        };
    }
    //UserEmail.split("@")[1]
    public render() {

        let rowcss = "ms-Grid-row miparow";

        const { isCalloutVisible, beakWidth } = this.state;
        let selectedCategory = null;
        let unAssignedUser = null;
        if (isCalloutVisible) {
            selectedCategory = this.prepareCategory(rowcss, true,false);
            unAssignedUser = this.prepareCategory(rowcss, false,false);
        }
        return (
            <React.Fragment>
                <div className="fieldcaption ms-Label label-180" style={{marginTop:'15px'}}>
                    <span title='Add category' style={{ cursor: 'pointer',float:'left',marginRight:'8px' }} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked}>
                        <i className="ms-Icon ms-Icon--Tag" style={{ fontSize:'20px' }}></i>
                        +
                    </span>
                    <ul className='catdisplay'>
                    {this.prepareCategory(rowcss, true,true)}
                </ul>
                </div>
               
                {isCalloutVisible ? (
                    <Callout

                        className="ms-Callout-callout"
                        onDismiss={this._onCalloutDismiss}
                        target={this._menuButtonElement}
                        directionalHint={DirectionalHint.topAutoEdge}
                        coverTarget={false}
                        isBeakVisible={true}
                        gapSpace={0}
                        beakWidth={beakWidth}
                    >
                        <div className='detailcallout'>

                            <div className="ms-Callout-inner" style={{ padding: '10px' }}>
                                <div className="ms-Callout-content ms-Grid">
                                    <div style={{textAlign:'right'}}>
                                        <button className='viewswitchbtn plannertask' onClick={()=>{
                                            this.originalAppCatList=JSON.parse(JSON.stringify(this.NewAppliedList));
                                            this.props.AddCategoryMethod(this.NewAppliedList);
                                            this._onMenuClicked();
                                        }} >Set</button>
                                    </div>
                                    <div className="assignedLabel">
                                        <span>Selected</span>
                                    </div>
                                    <div>
                                        {selectedCategory}
                                    </div>
                                    <div className="assignedLabel">
                                        <span>Not Selected</span>
                                    </div>
                                    <div>{unAssignedUser}</div>
                                </div>
                            </div>
                        </div>
                    </Callout>
                ) : null}

            </React.Fragment>
        );
    }
    private _onCalloutDismiss = (): void => {
        this.NewAppliedList=JSON.parse(JSON.stringify(this.originalAppCatList)) ;
        this.setState({
            isCalloutVisible: false
        });
    }

    private _onMenuClicked = (): void => {
        this.setState({
            isCalloutVisible: !this.state.isCalloutVisible
        });
    }
    private prepareCategory = (rowcss, forselected, fordisplay) => {
        let catlist = [];
        let defaultlist = Helper.GetPlanCatgory();
        defaultlist.forEach((cat, index) => {
            let catprop = 'category' + (index + 1);
            let catlabel = this.props.categoryDescriptions[catprop] ? this.props.categoryDescriptions[catprop] : cat.label;

            if (forselected) {
                if (this.NewAppliedList[catprop]) {
                    if(fordisplay){
                        catlist.push(
                            <li><span className='categoryitem' style={{ backgroundColor: cat.background, color: cat.color }} >
                            {catlabel}
                        </span></li>
                            
                        );
                    }else{
                        catlist.push(
                        <div style={{ marginTop: '2px', borderBottom: '1px solid #eee' }} title={catlabel} key={"Category" + index} className={rowcss}>
                            <div className="ms-Grid-col ms-sm10">
                                <span className='categoryitem' style={{ backgroundColor: cat.background, color: cat.color }} >
                                    {catlabel}
                                </span>

                            </div>
                            <div className='ms-Grid-col ms-sm2'><i title={this.props.Phrases.remove} onClick={() => { this.AddOrRemoveCategory(index, false); }} className="ms-Icon ms-Icon--ChromeClose x-hidden-focus" ></i></div>
                        </div>
                    );
                    }
                    
                }

            } else {
                if (!this.NewAppliedList[catprop]) {
                    catlist.push(
                        <div title={catlabel} key={"Category" + index} className={rowcss}>
                            <div className="ms-Grid-col ms-sm12" onClick={() => { this.AddOrRemoveCategory(index, true); }}>
                                <span className='categoryitem' style={{ backgroundColor: cat.background, color: cat.color }} >
                                    {catlabel}
                                </span>

                            </div>

                        </div>
                    );
                }
            }
        });

        /*
    if (remove) {
          return (<div key={"Assigned_" + user.id} className={rowcss}>
            <div className="ms-Grid-col ms-sm12 taskassinged">
              <div style={{ float: 'left' }}>
                <Facepile {...facepileProps} />
              </div>
              <i title={this.props.Phrases.remove} onClick={() => { this.assignuserToTask(user.id, false); }} className="ms-Icon ms-Icon--ChromeClose x-hidden-focus" ></i>
            </div>
    
          </div>);
        }
        else {
          return (<div key={"unassinged_" + user.id} className={rowcss}>
            <div style={{cursor:'pointer'}} className="ms-Grid-col ms-sm12 taskassinged" onClick={() => { this.assignuserToTask(user.id, true); }}>
              <Facepile {...facepileProps} />
            </div>
          </div>);
        }
        */
        return catlist;
    }

    private AddOrRemoveCategory = (index, foradd) => {
        let catprop = 'category' + (index + 1);
        //delete this.NewAppliedList[catprop];
        if (foradd) {
            this.NewAppliedList[catprop] = true;
        }else{
            this.NewAppliedList[catprop] = false;
        }
        //this.props.AddCategoryMethod(this.NewAppliedList);
        this.setState({ Changed: new Date() });
    }
}
